// @flow
// @jsx h

import { h, Component } from "preact";
import { Text } from "preact-i18n";

import { ThemeProvider, WidgetContextProvider } from "elc-theme";

// Translations
import { IntlProvider } from "preact-i18n";
import ca from "../../translations/ca.json";
import de from "../../translations/de.json";
import en from "../../translations/en.json";
import es from "../../translations/es.json";
import fr from "../../translations/fr.json";
import it from "../../translations/it.json";
import nl from "../../translations/nl.json";

import styles from "./ParticipantClientForms.scss";
import themeMarketplace from "./theme-marketplace.scss";


import { Booking } from "elc-basket";
import { route } from "preact-router";

import BookingParticipantClientForms from "./booking-participant-client-forms/BookingParticipantClientForms.js";

import {
  getOrderById,
  getParticipantClientForm,
  setGenerateTokenMethod,
  setToken
} from "elc-open-api";
import { PrimaryButton } from "elc-button";
import { generateTokenByOrderReference } from "elc-internal-api";
import ParticipantClientFormsHeader from "./ParticipantClientFormsHeader.js";

type ParticipantClientFormsComponentProps ={
  hash: string,
  config : WidgetConfig,
  order : Order,
  localeString : String,
  changeLoadingState:function,
  currency: Currency,
  token: string,
  allParticipantClientForm:any[],
  pageDidMountOrUpdate?:Function
}

type ParticipantClientFormsComponentState ={
  mobileDisplay: boolean,
  oneProductOneParticipant: boolean | null,
  changeLoadingState: boolean | null,
  isParticipantEmpty: boolean,
  order: Order,
  loading: boolean,
  localeString:string,
  locale:Object
}


export default class ParticipantClientForms extends Component<
  ParticipantClientFormsComponentProps,
  ParticipantClientFormsComponentState
> {

  constructor(props) {
    super(props);
    this.state = {
      mobileDisplay: true,
      oneProductOneParticipant: null,
      changeLoadingState: null,
      isParticipantEmpty: true,
      order: props.order || null,
      loading: true,
      localeString: props.localeString || "fr",
      locale: fr,
    };


    this.formsRefs = [];
    
    if (props.localeString) {
      this.changeLocale(props.localeString);
    }

    // set OpenAPI token
    if (props.token || props.orderRef == null) {
      setToken(props.token);
    }

  }

  componentDidMount() {     
    setGenerateTokenMethod(() =>
      generateTokenByOrderReference(this.props.orderRef),
    );

    if (
      this.props.allParticipantClientForm != null &&
      this.props.order != null
    ) {
      this.setState({ order : this.props.order});
      this.initForms(this.props.allParticipantClientForm);
    } else {
      getOrderById(this.props.orderId, this.props.orderRef)
        .then((order) => {
            // Si la locale de l oredr est différente de celle du state
            if (order.locale !== this.state.localeString) {

              // On retourne ici la deuxième requête avec la locale de l order
              return getOrderById(this.props.orderId, order.reference, order.locale)
                .then((updatedOrder) => {
                  // On renvoie updatedOrder
                  return updatedOrder;
                })
                .catch((error) => {
                  console.error("Error reloading order with new locale", error);
                  // Si erreur, on continue avec l’ordre original
                  return order;
                });
            }

            // Si locale déjà correcte
            return order;
          })
        .then((finalOrder) => {
            
            this.setState({ order : finalOrder , localeString : finalOrder.locale },
            () => {              
              this.changeLocale(finalOrder.locale);
            }
          );

          return Promise.all(
            finalOrder._embedded.bookings.map((booking) =>
              Promise.all([
                getParticipantClientForm(booking.id, finalOrder.locale).catch((error) => {
                  if (error.status !== 404) {
                    this.setState({ error });
                    // return Promise.reject();
                    throw new Error();
                  } else {
                    return;
                  }
                }),
                booking,
              ]),
            ),
          );
        })
        .then((responseArray) => {
          this.initForms(responseArray);

          return responseArray;
        })
        .catch((error) => {
          console.error("Error getParticipantClientForm", error);
        });
    }

    if (!window.matchMedia) return;
    this.mql = window.matchMedia(
      "(max-width: " +
        (styles.mobileMode ? styles.mobileMode : "53.750em") +
        ")",
    );
  }

componentDidUpdate(prevProps) {
    if (this.props.pageDidMountOrUpdate) {
      this.props.pageDidMountOrUpdate();
    }
  // Si la prop localeString change (depuis le parent) -
  if (this.props.localeString !== prevProps.localeString) {    
      getOrderById(this.state.order.id, this.state.order.reference, this.props.localeString)
            .then((order) => {
            
            this.setState({ order : order  },
            () => {              
              this.changeLocale(this.props.localeString);
            }
          );

          return Promise.all(
            order._embedded.bookings.map((booking) =>
              Promise.all([
                getParticipantClientForm(booking.id, this.props.localeString).catch((error) => {
                  if (error.status !== 404) {
                    this.setState({ error });
                    // return Promise.reject();
                    throw new Error();
                  } else {
                    return;
                  }
                }),
                booking,
              ]),
            ),
          );
        })
        .then((responseArray) => {
          this.initForms(responseArray);

          return responseArray;
        })
        .catch((error) => {
          console.error("Error getParticipantClientForm", error);
        });
    }
  }

  initForms = (responseArray) => {
          
    let bookingsParticipantClientForm = responseArray.filter((clientForm) => {
      return clientForm[0] !== undefined;
    });
    //  console.log("bookingsParticipantClientForm", bookingsParticipantClientForm)

    let oneProductOneParticipant =
      bookingsParticipantClientForm.length == 1 &&
      bookingsParticipantClientForm[0][1].quantity == 1;
    this.setState({ oneProductOneParticipant });

    this.setState(
      { bookingsParticipantClientForm },
      () => {
        this.props.changeLoadingState();
        this.setState({ loading: false });
        // this.checkValidParticipantForm();
      },
    );
  };

  changeLocale = (localeString: String) => {
    const locales = {fr,en,es,de,nl,it,ca};

    this.setState({localeString, locale: locales[localeString]});
  
        // Appel de la fonction du parent
  if (this.props.changeTranslation) {
    const country = { 
      "fr" : "FR",
      "en" : "GB",
      "de" : "DE",
      "nl" : "NL",
      "es" : "ES",
      "it" : "IT",
      "ca" : "PL",
     };
    this.props.changeTranslation(country[localeString]);
  }
  };

  validateAllForms = () => {
    const results = this.formsRefs.map((ref) => ref && ref.validate());
    const allValid = results.every((valid) => valid === true);
    return allValid;
  };

  handleSubmit = () => {
    
    if (this.validateAllForms()) {
      if (this.props.order == null) {
        route(`/participantclientforms/created`);
      } else {
        //si origin == OPEN_API      
        if(this.state.order.origin === "OPEN_API"){
          route(`/order/${this.state.order.id}`);
        }
        // sinon route classique
        else{
          route(`/order/${this.state.order.id}/client`);
        }
        
      }
    } else {
      //scroll premiére erreur dans la page
      setTimeout(() => {  
        const firstInvalid = document.querySelector('[data-invalid="true"]');
        if (firstInvalid) {
          firstInvalid.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      }, 100);
    }

  };



  componentWillUnmount() {}

  getWidgetContext = (configType: string, orderOrigin: string) => {
    return configType
      ? configType
      : orderOrigin === "KIOSK"
      ? "WIDGET"
      : orderOrigin;
  };

  getTheme = (configType: string, orderOrigin: string) => {
    return configType === "SHOP" ||
      orderOrigin === "SHOP" ||
      configType === "PMS" ||
      orderOrigin === "PMS"
      ? themeMarketplace
      : undefined;
  };

  render(
    { config, currency, pageDidMountOrUpdate },
    {
      bookingsParticipantClientForm,
      order,
      loading,
      oneProductOneParticipant,
      localeString,
      locale
    },
  ) {
    this.formsRefs = []; // reset à chaque render

    const currentTheme = this.getTheme(config?.type, order && order.origin);

    return (
      <ThemeProvider theme={currentTheme}>
        <IntlProvider definition={locale}>
          <WidgetContextProvider
            widgetContext={this.getWidgetContext(
              config?.type,
              order && order.origin,
            )}
          >
            
            {!loading && (
              <div>
                <ParticipantClientFormsHeader
                  textId={"participantClientForm.title"}
                  context={this.context}
                />
                <div class={styles.participantFormHeader}>
                  <Text id="participantClientForm.label" >
                    Merci de prendre un instant pour compléter le(s)
                    formulaire(s) suivant(s)
                  </Text>
                </div>

                <div class={styles.participantsContainer}>
                  <ul class={styles.bookingsList}>
                    {bookingsParticipantClientForm &&
                      bookingsParticipantClientForm.map(
                        ([participantClientForm, booking], index) => (
                          <li key={booking.id}>
                            <div class={styles.row}>
                              <div class={styles.cellBasket}>
                                <div class={styles.participantFormContainer}>
                                  <Booking
                                    key={booking.id}
                                    order={order}
                                    booking={booking}
                                    locale={localeString}
                                    currency={currency}
                                  />
                                </div>
                              </div>

                              <div class={styles.cellSummary}>
                                <div>
                                  <BookingParticipantClientForms
                                    key={booking.id} 
                                    ref={(ref) => (this.formsRefs[index] = ref)}
                                    booking={booking}
                                    participantClientForm={
                                      participantClientForm
                                    }
                                    localeString={localeString}
                                    oneProductOneParticipant={
                                      oneProductOneParticipant
                                    }
                                    currentTheme={currentTheme}
                                    pageDidMountOrUpdate={pageDidMountOrUpdate}
                                  />
                                </div>
                              </div>
                            </div>
                          </li>
                        ),
                      )}
                  </ul>
                  {/* bouton de validation */}
                  <div
                    class={
                      currentTheme && currentTheme.footerButton
                        ? currentTheme.footerButton
                        : styles.footerButton
                    }
                  >
                    <div class={styles.footerButtonContainer}>
                      <PrimaryButton
                        handleClick={this.handleSubmit}
                        className={styles.submitButton}
                      >
                        {oneProductOneParticipant ? (
                          <Text id="participantClientForm.submit">Valider</Text>
                        ) : (
                          <Text id="participantClientForm.validerForms">
                            Poursuivre ma commande
                          </Text>
                        )}
                      </PrimaryButton>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </WidgetContextProvider>
          </IntlProvider>
      </ThemeProvider>
    );
  }
}
